module.exports = __webpack_public_path__ + "img/id-2line.93e44680.svg";